import { render, staticRenderFns } from "./AdicionalesIndex.vue?vue&type=template&id=9ed31838"
import script from "./AdicionalesIndex.vue?vue&type=script&lang=js"
export * from "./AdicionalesIndex.vue?vue&type=script&lang=js"
import style0 from "./AdicionalesIndex.vue?vue&type=style&index=0&id=9ed31838&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports